import { render, staticRenderFns } from "./informationDetail.vue?vue&type=template&id=407238eb&scoped=true"
import script from "./informationDetail.vue?vue&type=script&lang=js"
export * from "./informationDetail.vue?vue&type=script&lang=js"
import style0 from "./informationDetail.vue?vue&type=style&index=0&id=407238eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407238eb",
  null
  
)

export default component.exports